import type React from 'react';
import { Switch } from '@/components/ui/switch';

interface TermCheckProps {
	label: string;
	name: string;
	checked: boolean;
	onCheckedChange: (checked: boolean) => void;
	icon: React.ElementType;
	error?: string;
}

const TermCheck = ({
	label,
	name,
	checked,
	onCheckedChange,
	icon: IconComponent,
	error
}: TermCheckProps): React.JSX.Element => {
	return (
		<div className="mb-3">
			<label
				htmlFor={name}
				className={`flex items-start p-6 bg-white border rounded-lg cursor-pointer transition-colors ${
					error ? 'border-destructive' : 'border-border'
				}`}
				data-testid={`switch-label-${name}`}
			>
				{/* Icon - hidden on small screens */}
				<div className="hidden sm:flex items-center justify-center shrink-0 w-20 h-20 mr-4">
					<IconComponent className="w-14 h-14 text-muted-foreground opacity-50" />
				</div>

				{/* Switch on the right */}
				<Switch
					id={name}
					checked={checked}
					onCheckedChange={onCheckedChange}
					className="order-last ml-auto shrink-0 h-7 w-12 data-[state=checked]:bg-primary data-[state=unchecked]:bg-input [&>span]:h-6 [&>span]:w-6 [&>span]:data-[state=checked]:translate-x-5"
					data-testid={`switch-${name}`}
				/>

				{/* Label text */}
				<span className="text-foreground mr-4 cursor-pointer">{label}</span>
			</label>
			{error && <p className="text-sm text-destructive text-center pt-2">{error}</p>}
		</div>
	);
};

export default TermCheck;
